import SalvPage from '../common/SalvPage';
import React from 'react';
import { SalvTable } from '@salvapp/ui-components';
import { createColumnHelper } from '@tanstack/react-table';
import { InternalApiReviewRequest, InternalApiReviewRequestEntityType } from '../api-internal';
import { useReviewRequests } from './reviewRequestActions';
import { formatDate } from '../common/datetime/FormattedDateTime';
import InternalLink from '../common/InternalLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { getScenarioPath, InternalNavigation } from '../navigation/helper';
import { formatEnumLabel } from '../common/helper';

const buildLink = (reviewRequest: InternalApiReviewRequest): string | null => {
  const { entityType, entityId, parentEntityId } = reviewRequest;
  switch (entityType) {
    case InternalApiReviewRequestEntityType.QUERY_TEMPLATE:
      return `${InternalNavigation.queryTemplates}?id=${entityId}`;
    case InternalApiReviewRequestEntityType.SCENARIO:
      return getScenarioPath(entityId);
    case InternalApiReviewRequestEntityType.SCENARIO_VERSION:
      return parentEntityId ? `${getScenarioPath(parentEntityId)}?version=${entityId}` : null;
    default:
      return null;
  }
};

const ReviewRequests = () => {
  const columnHelper = createColumnHelper<InternalApiReviewRequest>();
  const { data } = useReviewRequests();

  const columns = [
    columnHelper.accessor('entityType', {
      id: 'entityType',
      header: 'Entity Type',
      cell: ({ getValue }) => formatEnumLabel(getValue()),
    }),
    columnHelper.accessor('entityId', {
      id: 'entityId',
      header: 'Version',
      cell: ({ row }) => row.original.label || row.original.entityId,
    }),
    columnHelper.accessor('createdBy.name', {
      id: 'createdBy',
      header: 'Submitted By',
    }),
    columnHelper.accessor('createdTime', {
      id: 'createdTime',
      header: 'Created Time',
      cell: ({ getValue }) => formatDate(getValue()),
    }),
    columnHelper.display({
      id: 'link',
      header: '',
      cell: ({ row }) => {
        const link = buildLink(row.original);
        return link ? (
          <InternalLink
            title={
              <>
                Review <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: 16 }} />
              </>
            }
            link={link}
            ariaLabel={'Link for entity ' + row.original.entityId}
            onClickOpenInNewTab={true}
          />
        ) : null;
      },
    }),
  ];

  return (
    <SalvPage title='Review Requests'>
      <SalvTable columns={columns} data={data || []} />
    </SalvPage>
  );
};

export default ReviewRequests;
